import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { translate } from 'services/i18nService';

import styles from './index.css';


export default class AgeConsentSection extends PureComponent {
  static propTypes = { className: PropTypes.string };

  static defaultProps = { className: undefined };

  render() {
    const { className } = this.props;

    return (
      <div className={classNames(styles.container, className)}>
        <p>{translate('disclaimer.age.consent.p1')}</p>
        <ul>
          <li>{translate('disclaimer.age.consent.p1.ul1')}</li>
          <li>{translate('disclaimer.age.consent.p1.ul2')}</li>
          <li>{translate('disclaimer.age.consent.p1.ul3')}</li>
        </ul>
        <p>{translate('disclaimer.age.consent.p2')}</p>
        <ul>
          <li>{translate('disclaimer.age.consent.p2.ul1')}</li>
          <li>{translate('disclaimer.age.consent.p2.ul2')}</li>
          <li>{translate('disclaimer.age.consent.p2.ul3')}</li>
          <li>{translate('disclaimer.age.consent.p2.ul4')}</li>
          <li>{translate('disclaimer.age.consent.p2.ul5')}</li>
          <li>{translate('disclaimer.age.consent.p2.ul6')}</li>
          <li>{translate('disclaimer.age.consent.p2.ul7')}</li>
          <li>{translate('disclaimer.age.consent.p2.ul8')}</li>
          <li>{translate('disclaimer.age.consent.p2.ul9')}</li>
        </ul>
      </div>
    );
  }
}
